import React, { useState } from "react";
import { render } from "react-dom";
import ReactQuill from "react-quill";
import "./NewSeed.module.css"
import 'react-quill/dist/quill.snow.css';

function Editor({description, setDescription }:any) {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", ],
      [{ script:  "sub" }, { script:  "super" }],
      [{ size: [] }],
      [{ font: [] }],
      [{ align: ["right", "center", "justify"] }],
      [{ list: "ordered" }, { list: "bullet" }],
      // ["link", "image"],
      [{ color: ["red", "#785412", "blue"] }],
    ]
  };


  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "script",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "align",
    "font",
    "clean"
  ];

  const handleProcedureContentChange = (content:any, delta:any, source:any, editor:any) => {
    const htmlContent = editor.getHTML();
    setDescription(htmlContent);
  };

  return (
    <div className="quillBorder min-w-96">
   
      <ReactQuill
        modules={modules}
        formats={formats}
        value={description}
        onChange={handleProcedureContentChange}
        className=""
      />
    </div>
  );
}

export default Editor;